import { render } from "./VSD420-Fault.vue?vue&type=template&id=2820534f"
import script from "./VSD420-Fault.vue?vue&type=script&lang=js"
export * from "./VSD420-Fault.vue?vue&type=script&lang=js"

import "./VSD420-Fault.vue?vue&type=style&index=0&id=2820534f&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__